module.exports = __webpack_public_path__ + "img/emoji_21.9eb053eb.png";